import { render, staticRenderFns } from "./TempStaffBilling.vue?vue&type=template&id=80585542&scoped=true"
import script from "./TempStaffBilling.vue?vue&type=script&lang=js"
export * from "./TempStaffBilling.vue?vue&type=script&lang=js"
import style0 from "./TempStaffBilling.vue?vue&type=style&index=0&id=80585542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80585542",
  null
  
)

export default component.exports